import styled from "styled-components"
import { Colors } from "styles/app-styles"
import { TableDropdown_s } from "styles/input-styles"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"

// Override and customize PrimeReact data table styles

const DataTable_s = styled.div`
  height: 100%;
  overflow-y: auto;
  padding-bottom: 175px;

  table {
    border-spacing: 0;
    font-family: 'Roboto', sans-serif;
    width: 100%;
  }

  .p-datatable-thead .p-selection-column .p-checkbox-box {
    border: 1px solid darkgray !important;
  }

  .p-datatable-scrollable-body {
    padding-top: 37px;
    overflow-x: auto;
    z-index: 1;
  }

  .p-datatable-scrollable-view.p-datatable-unfrozen-view .p-datatable-scrollable-body {
    overflow-x: scroll;

    ::-webkit-scrollbar {
      background-color: #fff;
      width: 16px;
    }
    ::-webkit-scrollbar-button {
      display:none;
    }
    ::-webkit-scrollbar-thumb { /* Foreground */
      background-color: #babac0;
      border-radius: 16px;
      border: 4px solid #fff;
    }
    ::-webkit-scrollbar-track {
      background-color: #fff;
    }
  }

  // Header //

  .p-paginator {
    display: flex;
    flex-direction: row;
    font-weight: bold;
    height: 30px;
    justify-content: center;
    padding: 0;
    position: fixed;
    width: 100%;
    z-index: 2;

    .p-disabled {
      opacity: 0.5;
    }
    .p-paginator-element {
      font-size: 16px;
      color: ${Colors.denim};
      border: 0 !important;
      border-radius: 0;
      height: 30px;
      width: 22px;
    }
    .p-paginator-first, .p-paginator-last, .p-paginator-next, .p-paginator-prev {
      color:${Colors.blackPearl};
    }
    .p-paginator-pages .p-highlight{
      background-color: ${Colors.denim};
      color: ${Colors.white};
    }
    &.p-component.p-paginator-bottom {
      background-color: #F3F7FC;
      border-top: 1px solid ${Colors.towerGrey};
    }
    .p-dropdown {
      border: none !important;
      margin: 0;
      > .p-inputtext {
        padding: 0 15px 0 0;
        line-height: 30px;
      }
      li.p-dropdown-item {
        padding: 3px 0 3px 8px;
      }
    }
  }

  div.p-datatable-scrollable-header {
    background: ${Colors.white};
    padding-top: 5px;
    position: fixed;
    z-index: 2;
  }

  .p-datatable-header, .p-datatable-footer {
    padding: 5px;
  }

  div.p-datatable-scrollable-view.p-datatable-frozen-view thead.p-datatable-thead {
    background: ${Colors.towerGrey};
  }

  div.p-datatable-scrollable-view.p-datatable-unfrozen-view thead.p-datatable-thead > tr:nth-child(2) {
    height: 40px;
  }

  thead.p-datatable-thead {
    border-bottom: 2px solid ${Colors.towerGrey};
    span.p-column-title {
      font-weight: normal;
      line-height: 30px;
    }
    th.p-filter-column > div.p-dropdown {
      margin: 0;
      padding-left: 0;
    }
    th.p-filter-column > div.p-checkbox > .p-checkbox-box {
      border: 1px solid ${Colors.towerGrey};
      height: 16px;
      width: 16px;
    }
    > tr > th {
      padding: 0px 5px !important;
      &:first-child:not(.p-selection-column, .p-filter-column) {
        padding: 0px 5px 0px 15px !important;
      }
      &:first-child.p-selection-column {
        padding-left: 8px !important;
        text-overflow: clip;
      }
      &:nth-child(2).p-index-column {
        padding-left: 0 !important;
      }
    }
  }

  thead.p-datatable-thead, .p-sortable-column {
    color: ${Colors.darkDenim};
    font-size: 14px;
    font-weight: 400;
    /* PR floats this */
    text-align: left;
  }

  .p-datatable-header input[type="search"] {
    border: 1px solid ${Colors.towerGrey};
    padding-right: 4px;
    &::placeholder {
      color: ${Colors.towerGrey};
    }
  }
  .pi-sort {
    float: right;
  }
  .p-column-filter {
    display: block;
    padding: 0.429em;
    border: 1px solid #a6a6a6 !important;
    border-radius: 3px;
    width: 100%;
  }

  // Rows //

  .p-datatable-tbody > tr {
    height: 30px !important;
    &:nth-child(2n){
      background: ${Colors.lightMystic};
    }
  }
  // PrimeReact have to add border to td and not tr
  .p-datatable-tbody > tr:first-child > td {
    border-top: 1px solid ${Colors.towerGrey};
  }

  .error-row {
    background: ${Colors.inputWarning} !important;
  }

  // Columns //

  // Row select column
  .p-selection-column {
    width: 2em;
    > .p-radiobutton > .p-radiobutton-box {
      border: 1px solid ${Colors.darkDenim};
      > span.p-radiobutton-icon {
        color: ${Colors.darkDenim};
      }
    }
    .p-checkbox {
      font-size: 10px;
      vertical-align: middle;
      > .p-checkbox-box {
        border: 1px solid ${Colors.towerGrey};
        height: 18px;
        width: 18px;
        > span.p-checkbox-icon {
          font-weight: bold;
          margin: 2px;
        }
      }
    }
  }

  // Cells //

  .p-datatable-tbody > tr > td {
    border-bottom: 1px solid ${Colors.towerGrey};
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    white-space: nowrap;
  }

  .p-datatable-tbody > tr > td > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  div.p-datatable-scrollable-view.p-datatable-frozen-view .p-datatable-tbody td {
    &:first-child:not(.p-selection-column, .p-filter-column) {
      padding: 0px 5px 0px 15px !important;
    }
  }

  div.p-datatable-scrollable-view.p-datatable-unfrozen-view .p-datatable-tbody td {
    &:first-child:not(.p-selection-column, .p-filter-column) > span, &:first-child:not(.p-selection-column, .p-filter-column) > input {
      padding-left: 15px;
    }
    > span {
      display: inline-block;
      padding-left: 5px;
      vertical-align: middle;
      width: calc(100% - 5px);
    }
    > input {
      padding-left: 5px;
    }
  }

  .has-errors {
    background-color: ${Colors.inputError} !important;
    border-bottom-color: ${Colors.colorDanger} !important;
  }

  // Selected cell //

  .automated:focus, .automated-secondary:focus, .p-focus {
    outline: 2px solid ${Colors.blackPearl}; outline-offset: -1px;
  }

  .p-cell-editing {
    font-size: 14px;
    overflow: visible !important;
    input {
      font-size: 14px;
    }
    .rw-widget, input:focus {
      border: 0 !important;
    }
  }

  td.p-editable-column.p-cell-editing {
    padding: 0px !important;
  }

  /* Override Input Styling */
  .p-editable-column input {
    width: 100%;
  }

  // Dropdowns //
  div.p-datatable-scrollable-view.p-datatable-unfrozen-view .p-datatable-tbody tr > td:first-child {
    ${TableDropdown_s}{ padding-left: 11px; }
  }

  // Checkboxes //
  .p-datatable-tbody > tr > td.p-editable-column {
    > div.p-checkbox > .p-checkbox-box {
      margin-left: 5px;
    }
    > div.p-checkbox, > span > div.p-checkbox {
      height: 16px;
      margin-top: -2px !important;
      vertical-align: middle;
      .p-checkbox-box {
        width: 16px !important;
      }
    }
  }
  .p-datatable-tbody > tr > td.p-editable-column {
    div.p-checkbox > .p-checkbox-box {
      margin-left: 0px;
      > span.p-checkbox-icon {
        font-size: 10px;
      }
    }
  }
  .p-cell-editing > .p-checkbox.p-component {
    margin-left: 5px !important;
    .p-focus {
      margin-left: 0px;
    }
  }
  .p-cell-editing > .p-checkbox.p-component > .p-checkbox-box.p-component.p-highlight {
    height: 16px !important;
    width: 16px !important;
    margin-left: 0px !important;
    .p-checkbox-icon {
      display: block;
      margin-right: 4px;
    }
  }

  // Text Input
  input.p-inputtext {
    &:not(.has-errors) {
      border: 1px solid ${Colors.towerGrey} !important;
    }
    &.has-errors {
      border: 1px solid ${Colors.towerGrey};
    }
    border-radius: 2px;
    height: 30px;
    margin-bottom: 0px;
  }
  .p-column-filter.p-inputtext {
    margin-bottom: 4px;
  }

  input:focus {
    outline: none;
  }

  // Messages
  .p-datatable-frozen-view .p-datatable-emptymessage {
    visibility: hidden;
  }

  // Footer
  .selection-count {
    bottom: 55px;
    font-size: smaller;
    left: 5px;
    position: absolute;
    z-index: 999;
  }
`

interface DetailedRouteUpDownProps {
  disabled?: boolean
}

export const DetailedRouteUpDown_s = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  margin-left: 8px;
`

export const DetailedUpDownBtn_s = styled.a<DetailedRouteUpDownProps>`
  height: 15px !important;
  pointer-events: ${props => props.disabled ? 'none' : ''};
  opacity: ${props => props.disabled ? '0.5' : '1'};
  svg {
    height: 20px;
    .r-svg { fill: ${Colors.blackPearl}; }
  }
`

export default DataTable_s